import { useCallback, useState } from "react";
import eligibilityCheckServices from "../../../../services/api/service/eligibilityCheckService";
import { decodeBase64FileToUrl } from "../../../../components/Form/StepperDyanmicForm/helper";

export function useDocumentPreview({
  applicationNumber,
}: {
  applicationNumber: any;
}) {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [viewDocUrl, setViewDocUrl] = useState("");
  const [viewDocMimeType, setViewDocMimeType] = useState("");

  const closePreview = useCallback(() => {
    setIsPreviewOpen(false);
  }, []);

  const openPreview = useCallback((url: string, mimeType = "") => {
    setViewDocUrl(url);
    setViewDocMimeType(mimeType);
    setIsPreviewOpen(true);
  }, []);

  const handlePreviewDocument = useCallback(async (docPath: string) => {
    const payload = { key: docPath };
    const response = await eligibilityCheckServices.previewDocument(payload);
    if (response?.status === 200) {
      openPreview(response?.data?.data?.downloadUrl || "", "");
    }
  }, [openPreview]);

  const handlePreviewAggregateDocument = useCallback(async (docPath: string) => {
    const payload = { key: docPath };
    const response = await eligibilityCheckServices.previewAggregateDocument(payload);
    if (response?.status === 200) {
      openPreview(response?.data?.data?.downloadUrl || "", "");
    }
  }, [openPreview]);

  const handlePreviewDownloadDocument = useCallback(
    async (uuid: string, s3Location: string) => {
      let payload: any = {
        trackingId: applicationNumber,
      };

      if (uuid) {
        payload.uuid = uuid
      }
      if (s3Location) {
        payload.s3location = s3Location
      }

      const response = await eligibilityCheckServices.downloadDocument(payload);

      console.log("response", response?.data?.data);

      if (response?.status === 200) {
        const base64Data = response?.data?.data?.data;
        const downloadUrl = response?.data?.data;
        if (payload.s3location) {
          openPreview(downloadUrl, "");
        } else if (payload.uuid) {
          const { url, mimeType } = decodeBase64FileToUrl(base64Data);
          openPreview(url, mimeType);
        }
      }
    },
    [applicationNumber, openPreview]
  );

  return {
    isPreviewOpen,
    viewDocUrl,
    viewDocMimeType,
    openPreview,
    closePreview,
    handlePreviewDocument,
    handlePreviewAggregateDocument,
    handlePreviewDownloadDocument,
  };
}

